import http from "./http";

import {useRequest} from "ahooks";
import ls from "../utils/ls";

let apiPath = {
  qryExpressFee: '/tools/expressTemplate/qryExpressFee'
};

export const useQryExpressFee = (query, reqConfig) => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    const shopList = ls.getConfirmGoodsList();
    const expressShopParams = shopList.map(item => {
      return {
        shopId: item.shopId,
        expressItemParams: item.goodsList.map(goods => {
          return {
            itemId: goods.itemId,
            num: goods.quantity,
          };
        })
      };
    });
    
    let json = {
      cityId: q.cityId,
      countyId: q.countyId,
      provinceId: q.provinceId,
      expressShopParams,
    };
    
    return http({
      url: apiPath.qryExpressFee,
      method: 'post',
      data: json || {},
    }, { noAlias: true, json: true });
  }, { manual: true, ...reqConfig });
  
  return {
    result: data || {},
    loading,
    error,
    getExpressFee: runAsync
  };
};
